import React from 'react'
import { useTranslation } from 'react-i18next'
import ShowPartners from '../components/Partners/ShowPartners'

const Partners:React.FC = () => {
  const { t } = useTranslation()
  return (
    <div className='mt-20'>
      <h1 className='text-center text-3xl'>{t("Partenaires")}</h1>
      <ShowPartners />
    </div>
  )
}

export default Partners